import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import cn from "twsx";

// Linear segmented control: pill segments, 24px, 12/500. The pressed segment
// takes the selected-tab fill and ring. Segments are toggle buttons
// (`aria-pressed`), so a form can bind one value to them.
/** Use when switching between two to five views or modes in place. */
const SegmentedControl = t0 => {
  const $ = _c(10);
  let className;
  let props;
  let ref;
  if ($[0] !== t0) {
    ({
      className,
      ref,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = ref;
  } else {
    className = $[1];
    props = $[2];
    ref = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("inline-flex w-fit items-center gap-0.5 rounded-full border border-border-input bg-bg-surface p-0.5", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== props || $[7] !== ref || $[8] !== t1) {
    t2 = <div ref={ref} role="group" className={t1} {...props} />;
    $[6] = props;
    $[7] = ref;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};
SegmentedControl.displayName = "SegmentedControl";
const SegmentedControlItem = t0 => {
  const $ = _c(14);
  let className;
  let pressed;
  let props;
  let ref;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      pressed,
      variant: t1,
      ref,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = pressed;
    $[3] = props;
    $[4] = ref;
    $[5] = t1;
  } else {
    className = $[1];
    pressed = $[2];
    props = $[3];
    ref = $[4];
    t1 = $[5];
  }
  const variant = t1 === undefined ? "neutral" : t1;
  let t2;
  if ($[6] !== className || $[7] !== variant) {
    t2 = cn("inline-flex h-6 items-center justify-center gap-1 rounded-full px-3", "text-sm font-medium text-text-tertiary outline-none [&_svg]:size-3.5 [&_svg]:shrink-0", "hover:bg-fill-hover hover:text-text-secondary", "focus-visible:outline focus-visible:outline-1 focus-visible:-outline-offset-1 focus-visible:outline-accent", variant === "accent" ? ["aria-pressed:bg-accent aria-pressed:text-text-on-accent", "aria-pressed:hover:bg-accent-hover aria-pressed:hover:text-text-on-accent"] : "aria-pressed:bg-fill-segment-on aria-pressed:text-text-primary aria-pressed:shadow-tab-selected", "disabled:cursor-not-allowed disabled:opacity-disabled", className);
    $[6] = className;
    $[7] = variant;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== pressed || $[10] !== props || $[11] !== ref || $[12] !== t2) {
    t3 = <button ref={ref} type="button" aria-pressed={pressed} className={t2} {...props} />;
    $[9] = pressed;
    $[10] = props;
    $[11] = ref;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
};
SegmentedControlItem.displayName = "SegmentedControlItem";
export { SegmentedControl, SegmentedControlItem };